import { IconButton, InputAdornment } from '@mui/material'
import { useEffect, useState } from 'react'
import SearchIcon from '@mui/icons-material/Search'
import { SearchButton, SearchInput, SearchInputContainer } from './styled'
import CloseIcon from '@mui/icons-material/Close'
import { useRouter } from 'next/router'

const BlogSearchInput = ({
  setSearchTerm,
  searchTerm,
}: {
  setSearchTerm: (e: string) => void
  searchTerm: string
}) => {
  const router = useRouter()
  const [searchInput, setSearchInput] = useState(searchTerm)

  const handleSearch = (term: string) => {
    setSearchTerm(term)

    router.push(
      {
        pathname: router.pathname,
        query: {
          ...router.query,
          search: term,
        },
      },
      undefined,
      { shallow: true },
    )
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }, [searchTerm])

  const handleClear = () => {
    setSearchTerm('')
    setSearchInput('')

    const query = { ...router.query }

    delete query.search

    router.push(
      {
        pathname: router.pathname,
        query,
      },
      undefined,
      { shallow: true },
    )
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    handleSearch(searchInput)
  }

  return (
    <form onSubmit={handleSubmit}>
      <SearchInputContainer>
        <SearchInput
          label=""
          placeholder="Search"
          autoComplete="off"
          name="search"
          onChange={(e) => setSearchInput(e.target.value)}
          value={searchInput}
          InputProps={{
            endAdornment: searchInput && (
              <InputAdornment position="end">
                <IconButton onClick={handleClear} edge="end" size="small" aria-label="clean">
                  <CloseIcon color="primary" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <SearchButton type="submit" buttonvariant="cta2">
          <SearchIcon fontSize="small" />
        </SearchButton>
      </SearchInputContainer>
    </form>
  )
}

export default BlogSearchInput
